export { default as LifestylesMaterialsFilterBadge } from './LifestylesMaterialsFilterBadge';
